export default function ScanLines() {
  return (
    <div 
      className="pointer-events-none absolute inset-0 z-50"
      style={{
        background: 'linear-gradient(transparent 50%, rgba(0, 255, 255, 0.02) 50%)',
        backgroundSize: '100% 4px',
        mixBlendMode: 'overlay',
      }}
    />
  );
}